/**
 * @fileoverview Route component reproducing the Angular `redirectGuard`.
 * @module app/guards/RootRedirect
 * @description
 * React port of `redirectGuard` (`angular/src/app/guards/redirect.guard.ts`).
 * Handles the index route (`''`): the root never renders content, it always
 * redirects. Reproduces the Angular logic exactly:
 *
 *   - If `data.isLoading` (session init) -> `/login` (Angular defaulted to login
 *     during initialization).
 *   - Else -> `/<getNextStep()>`.
 *
 * @author Liraz Amir
 */

import { Navigate } from 'react-router-dom';
import { useDataStore } from '@/stores/data.store';
import { useAuthStore } from '@/stores/auth.store';

export function RootRedirect() {
  const dataLoading = useDataStore((s) => s.isLoading);

  if (dataLoading) {
    return <Navigate to="/login" replace />;
  }

  const nextStep = useAuthStore.getState().getNextStep();
  return <Navigate to={`/${nextStep}`} replace />;
}

export default RootRedirect;
